import { createContext, useContext } from 'react'
import { Appointment } from '@myapp/contract'

interface AppointmentEditContextValue {
  appointmentId: string | undefined
  onEditingAppointmentLoaded: ((appointment: Appointment) => void) | undefined
}

const AppointmentEditContext = createContext<AppointmentEditContextValue>({
  appointmentId: undefined,
  onEditingAppointmentLoaded: undefined,
})

export const AppointmentEditProvider = AppointmentEditContext.Provider

export function useAppointmentEditContext(): AppointmentEditContextValue {
  return useContext(AppointmentEditContext)
}
